import { Button, Grid, TextField, MenuItem } from "@mui/material";
import { useContext } from "react";
import { customerUsersContext } from '../CustomerUsersContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";
import { FilterContainer } from "components";

let Filter = () => {
    let { formatMessage } = useIntl();

    let service = useContext(customerUsersContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item>
                <TextField
                    label={formatMessage({ id: LocalizationIds.SearchUsers })}
                    size="small"
                    value={service.search.searchText}
                    onChange={(e: any) => service.updateSearch({ ...service.search, searchText: e.target.value })}
                />
            </Grid>
            <Grid item>
                <TextField
                    select
                    label={formatMessage({ id: LocalizationIds.ShowOnly })}
                    size="small"
                    value={service.search.showOnly}
                    onChange={(e: any) => service.updateSearch({ ...service.search, showOnly: e.target.value })}
                >
                    <MenuItem value="active">{formatMessage({ id: LocalizationIds.ActiveUsers })}</MenuItem>
                    <MenuItem value="deleted">{formatMessage({ id: LocalizationIds.DeletedUsers })}</MenuItem>
                </TextField>
            </Grid>

            <Grid item>
                <Button
                    type="submit"
                    color="secondary"
                    variant="outlined"
                    aria-label="search"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;